import HomePage from "./pages/home";
import Header from "./components/header";
function App() {
  return (
    <div className="App">
      <Header/>
      <HomePage/>
    </div>
  );
}

export default App;
